import { Flex, Typography } from "antd";
import { Empty } from "components/Empty";
import { useTranslate } from "@refinedev/core";

export const NoInsights = () => {
  const t = useTranslate();

  return (
    <Empty
      description={
        <Flex vertical align="center" gap={4}>
          <Typography.Text>
            {t("media.analytics.insights.empty")}
          </Typography.Text>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            {t("media.analytics.insights.emptyDescription")}
          </Typography.Text>
        </Flex>
      }
    />
  );
};
